import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { fieldImage } from "../../lib/fieldImages";
import { MapPin, ChevronRight, Droplets, Sprout } from "lucide-react";
import { SmartImage } from "../common/SmartImage";

const pick = (lang, hi, en) => (lang === "English" ? en : hi);

export function FieldsCarousel({ fields, language, item }) {
  if (!fields?.length) return null;
  return (
    <motion.div variants={item} data-testid="fields-carousel">
      <div className="flex items-center justify-between mb-2">
        <h2 className="font-display font-bold text-[17px] text-[#173f1e] flex items-center gap-2"><MapPin className="h-5 w-5 text-[#2f9e3a]" />{pick(language, "मेरे खेत", "My Fields")}</h2>
        <Link to="/farms" className="text-sm font-semibold text-[#2f7d33] flex items-center tap" data-testid="fields-see-all">{pick(language, "सभी देखें", "See all")}<ChevronRight className="h-4 w-4" /></Link>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1 no-scrollbar">
        {fields.slice(0, 8).map((f, i) => (
          <Link to="/farms" key={`${f.id || "fld"}-${i}`} className="shrink-0 w-44 rounded-2xl overflow-hidden agro-glass tap active:scale-[0.98] transition-transform" data-testid={`field-card-${i}`}>
            <div className="h-24 relative">
              <SmartImage src={fieldImage(i)} alt={f.name} className="absolute inset-0 h-full w-full" fallback={Sprout} />
              <div className="absolute inset-0 pointer-events-none" style={{ background: "linear-gradient(180deg,rgba(0,0,0,0) 40%,rgba(0,0,0,0.55))" }} />
              <p className="absolute bottom-1.5 left-2.5 right-2.5 text-white font-bold text-sm truncate drop-shadow">{f.name}</p>
            </div>
            <div className="p-3 flex items-center justify-between">
              <div className="min-w-0">
                <p className="text-[13px] font-semibold text-[#173f1e]">{f.areaAcres} {pick(language, "एकड़", "ac")}</p>
                <p className="text-[11px] text-[#6c7a67] truncate">{f.soilType}</p>
              </div>
              <span className="text-[10px] text-sky-600 flex items-center gap-0.5 shrink-0"><Droplets className="h-3 w-3" />{f.irrigationSource}</span>
            </div>
          </Link>
        ))}
      </div>
    </motion.div>
  );
}
